import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./About.css";

const expertiseBars = [
  { label: "Matériels de lutte contre l'incendie", value: 100 },
  { label: "Équipements pétroliers", value: 100 },
  { label: "Robinetterie et instrumentation", value: 100 },
  { label: "Équipements de salle de lavage", value: 100 },
  { label: "Équipements hydrauliques", value: 100 },
];

const engagements = [
  { icon: "🌍", title: "Durabilité" },
  { icon: "🛠️", title: "Innovation" },
  { icon: "🤝", title: "Fiabilité" },
  { icon: "🎯", title: "Excellence" },
];

const partners = [
  { src: "/assets/images/p1.webp", alt: "Partenaire 1" },
  { src: "/assets/images/p2.jpg", alt: "Partenaire 2" },
  { src: "/assets/images/p3.png", alt: "Partenaire 3" },
  { src: "/assets/images/p4.jpg", alt: "Partenaire 4" },
  { src: "/assets/images/p5.jpg", alt: "Partenaire 5" },
  { src: "/assets/images/p6.png", alt: "Partenaire 6" },
  { src: "/assets/images/p7.jpg", alt: "Partenaire 7" },
  { src: "/assets/images/p8.jpg", alt: "Partenaire 8" },
  { src: "/assets/images/p9.jpg", alt: "Partenaire 9" },
];

function About() {
  /* ── Animate expertise bars on scroll ── */
  const barsRef = useRef(null);
  const [barsVisible, setBarsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) setBarsVisible(true);
      },
      { threshold: 0.3 }
    );
    if (barsRef.current) observer.observe(barsRef.current);
    return () => observer.disconnect();
  }, []);

  /* ── Slider settings ── */
  const sliderSettings = {
    dots: false,
    arrows: false,
    infinite: true,
    speed: 600,
    slidesToShow: 5,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2500,
    pauseOnHover: true,
    responsive: [
      { breakpoint: 1024, settings: { slidesToShow: 4 } },
      { breakpoint: 768, settings: { slidesToShow: 3 } },
      { breakpoint: 480, settings: { slidesToShow: 2 } },
    ],
  };

  return (
    <div>
      {/* ═══════ Hero / Breadcrumb ═══════ */}
      <section className="about-hero">
        <div className="about-hero__container">
          <span className="about-hero__label">À propos de nous</span>
          <h1 className="about-hero__title">
            Qui <span>Sommes-Nous</span>
          </h1>
          <div className="about-hero__breadcrumb">
            <Link to="/">Accueil</Link>
            <span>/</span>
            <span>Qui sommes-nous</span>
          </div>
        </div>
      </section>

      {/* ═══════ Values Cards ═══════ */}
      <section className="about-values">
        <div className="about-values__container">
          <div className="about-values__grid">
            {/* Vision */}
            <div className="value-card">
              <div className="value-card__header">
                <div className="value-card__icon value-card__icon--vision">🔭</div>
                <div className="value-card__info">
                  <p>Notre</p>
                  <h4>Vision</h4>
                </div>
              </div>
              <p className="value-card__desc">
                Être le fournisseur d'équipements hydrauliques, industriels et
                pétroliers de référence en Tunisie et au Maghreb, reconnu pour
                son excellence en matière de qualité, d'innovation et de
                satisfaction client.
              </p>
            </div>

            {/* Mission */}
            <div className="value-card">
              <div className="value-card__header">
                <div className="value-card__icon value-card__icon--mission">🎯</div>
                <div className="value-card__info">
                  <p>Notre</p>
                  <h4>Mission</h4>
                </div>
              </div>
              <p className="value-card__desc">
                Offrir des équipements hydrauliques, industriels et pétroliers de
                qualité supérieure qui répondent aux besoins exigeants de nos
                clients, à des prix compétitifs.
              </p>
            </div>

            {/* Services */}
            <div className="value-card">
              <div className="value-card__header">
                <div className="value-card__icon value-card__icon--services">🏆</div>
                <div className="value-card__info">
                  <p>Nos</p>
                  <h4>Services</h4>
                </div>
              </div>
              <p className="value-card__desc">
                BOUCHADDAKH s'engage à fournir des produits d'une qualité
                irréprochable et un service client irréprochable. Notre priorité
                absolue est la satisfaction de nos clients.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* ═══════ Story Section ═══════ */}
      <section className="about-story">
        <div className="about-story__container">
          <div className="about-story__content">
            <span className="section-label">Votre Partenaire De Confiance</span>
            <h2 className="section-title">
              Expert en équipements hydrauliques, industriels et pétroliers
            </h2>
            <p className="about-story__text">
              Depuis de nombreuses années, BOUCHADDAKH s'impose comme un
              partenaire de confiance dans la fourniture d'équipements
              hydrauliques, industriels et pétroliers de qualité supérieure.
              Notre engagement envers la satisfaction client est au cœur de
              notre politique d'entreprise, ce qui se traduit par une maîtrise
              permanente de la qualité des produits et services proposés.
            </p>
            <p className="about-story__text">
              Notre expertise et notre service client irréprochable font de
              BOUCHADDAKH le choix idéal pour vos besoins en équipements
              hydrauliques, industriels et pétroliers.
            </p>
          </div>
          <div className="about-story__image-wrapper">
            <div className="about-story__accent" />
            <div className="about-story__image">
              <img src="/assets/images/ans2.png" alt="BOUCHADDAKH équipe" />
            </div>
          </div>
        </div>
      </section>

      {/* ═══════ Expertise / Sectors ═══════ */}
      <section className="about-expertise">
        <div className="about-expertise__container">
          <div className="about-expertise__bars" ref={barsRef}>
            {expertiseBars.map((bar, i) => (
              <div className="expertise-bar" key={i}>
                <div className="expertise-bar__label">
                  <h6>{bar.label}</h6>
                </div>
                <div className="expertise-bar__track">
                  <div
                    className="expertise-bar__fill"
                    style={{ width: barsVisible ? `${bar.value}%` : "0%" }}
                  />
                </div>
              </div>
            ))}
          </div>

          <div className="about-expertise__content">
            <span className="section-label">Expertise</span>
            <h2 className="section-title">Nos Secteurs D'activités</h2>
            <p className="section-desc" style={{ margin: 0, maxWidth: "100%" }}>
              Nous opérons dans divers secteurs, offrant des solutions adaptées
              aux industries pétrolières, hydrauliques et industrielles. Grâce à
              notre expertise et à notre engagement envers la qualité, nous
              accompagnons nos clients dans l'acquisition d'équipements
              performants et innovants.
            </p>
            <Link to="/produits" className="about-expertise__btn">
              Voir nos produits →
            </Link>
          </div>
        </div>
      </section>

      {/* ═══════ Quality Section ═══════ */}
      <section className="about-quality">
        <div className="about-quality__container">
          <div className="about-quality__content">
            <span className="section-label">Qualité</span>
            <h2 className="section-title">
              Notre Engagement envers la Qualité
            </h2>
            <p className="about-quality__text">
              Chez BOUCHADDAKH, la qualité est au cœur de notre démarche. Nous
              sélectionnons rigoureusement nos fournisseurs et appliquons des
              normes strictes pour garantir la fiabilité et la durabilité de nos
              équipements. Notre engagement est de fournir des solutions
              performantes qui répondent aux attentes les plus exigeantes de nos
              clients.
            </p>
          </div>
          <div className="about-quality__image-wrapper">
            <img
              src="/assets/images/banner3.jpg"
              alt="Qualité BOUCHADDAKH"
            />
          </div>
        </div>
      </section>

      {/* ═══════ Engagement Values ═══════ */}
      <section className="about-engagement">
        <div className="about-engagement__container">
          <div className="section-header" style={{ textAlign: "center" }}>
            <span
              className="section-label"
              style={{
                background: "rgba(79,140,255,0.15)",
                color: "#93bbff",
              }}
            >
              Valeurs
            </span>
            <h2 className="section-title" style={{ color: "#fff" }}>
              Notre Engagement
            </h2>
          </div>

          <div className="about-engagement__grid">
            {engagements.map((e, i) => (
              <div className="engagement-card" key={i}>
                <span className="engagement-card__icon">{e.icon}</span>
                <h4 className="engagement-card__title">{e.title}</h4>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ═══════ Partners ═══════ */}
      <section className="about-partners">
        <div className="about-partners__container">
          <div className="section-header">
            <span className="section-label">Confiance</span>
            <h2 className="section-title">Nos Partenaires</h2>
            <p className="section-desc">
              Nous collaborons avec les plus grandes marques mondiales pour vous
              offrir le meilleur.
            </p>
          </div>

          <div className="about-partners__slider">
            <Slider {...sliderSettings}>
              {partners.map((p, i) => (
                <div key={i}>
                  <div className="partner-logo">
                    <img src={p.src} alt={p.alt} />
                  </div>
                </div>
              ))}
            </Slider>
          </div>
        </div>
      </section>
    </div>
  );
}

export default About;
